import { parseInstrument } from '../../instrumentUtils';
import type { WidgetDefinition } from '../WidgetDefinition';
import { faTableTree } from '@fortawesome/pro-regular-svg-icons/faTableTree';
import type { ExecutionsWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { ExecutionsWidgetViewModel } from 'src/store/types';

class ExecutionsWidgetDefinition implements WidgetDefinition<ExecutionsWidgetViewModel, ExecutionsWidgetModel> {
    type = 'executions' as const;
    nameKey = 'widgets::executions::name' as const;
    roles = ['widgets::executions'];
    icon = faTableTree;
    category = 'widgets::categories::risk' as const;

    /**
     * Converts an Executions widget from contract model to view model
     */
    toViewModel(widget: ExecutionsWidgetModel): ExecutionsWidgetViewModel {
        return {
            ...widget,
            instrument: parseInstrument(''),
            type: 'executions',
        };
    }

    /**
     * Converts an Executions widget from view model to contract model
     */
    toContractModel(widget: ExecutionsWidgetViewModel): ExecutionsWidgetModel {
        const { instrument: _instrument, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const executionsWidgetDefinition = new ExecutionsWidgetDefinition();
